export default __webpack_public_path__ + "static/media/SiddhardhPalaparthi.b1efe684.pdf";